import styled from 'styled-components';

import { SkeletonBlurb } from 'components/Containers';
import { colors } from 'styles/theme/colors';

/**
 * Placeholder rows while a thread loads.
 *
 * Without it the tab shows blank space between the composer and wherever the notes land, which
 * reads as "no notes yet" for a beat before they appear — and the thread refetches on every
 * open, so that flash happens every visit, not just the first.
 *
 * The shapes mirror NoteRow: an author line and a timestamp on one row, then two body lines.
 */
export default function SkeletonNoteList() {
  return (
    <div data-testid='notes-skeleton' aria-hidden>
      {[0, 1, 2].map((i) => (
        <SkeletonRow key={i}>
          <Header>
            <Blank $width={120} $height={14} />
            <Blank $width={70} $height={12} />
          </Header>
          <Blank $width='100%' $height={12} />
          <Blank $width='60%' $height={12} />
        </SkeletonRow>
      ))}
    </div>
  );
}

// Matches NoteRow's spacing — uniform on every row, including the first — so the real notes do not
// shift when they replace these.
const SkeletonRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 0;

  & + & {
    border-top: 1px solid ${colors.black10};
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Blank = styled(SkeletonBlurb)<{ $width: number | string; $height: number }>`
  width: ${({ $width }) => (typeof $width === 'number' ? `${$width}px` : $width)};
  height: ${({ $height }) => $height}px;
  border-radius: 4px;
`;
